$('.modal').on('show.bs.modal', function () {
    const modal = $(this);

    $(this).find('[data-bs-fadeout="modal"]').on('click', function() {
        modal.on("transitionend", function() {
            modal.modal('hide');
        })

        modal.removeClass('fade').addClass('fade-out')
    })
})